import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useFilters } from '../../../../hooks/useFilters';
import { IMembershipPlanPriceModel } from '../../../../models/MembershipPlanPriceModel';
import { SelectOption } from '../../../../models/SelectOption';

import { subscriptionsListSelector } from '../../../../store/redux-slices/subscriptions/common/selectors';
import { formatDate } from '../../../../utils/dateHelpers';
import { KEMembersListFilters } from './keMembersFilters.models';

type UseKEMembersFiltersProps = {
  standardPricing?: IMembershipPlanPriceModel[];
};

export const useKEMembersFilters = ({
  standardPricing,
}: UseKEMembersFiltersProps) => {
  const subscriptionsList = useSelector(subscriptionsListSelector);

  const { addFilter, filters } = useFilters<KEMembersListFilters>();

  const onFilterChangeHandler = useCallback(
    (evt: any, filterType: KEMembersListFilters) => {
      switch (filterType) {
        case KEMembersListFilters.Search:
          addFilter(KEMembersListFilters.Search, evt.target.value);
          return;
        case KEMembersListFilters.Plan:
          addFilter(
            KEMembersListFilters.Plan,
            evt ? evt.map((x: SelectOption) => x.value) : null,
          );
          return;
        case KEMembersListFilters.MemberType:
          addFilter(
            KEMembersListFilters.MemberType,
            evt ? evt.map((x: SelectOption) => x.value) : null,
          );
          return;
        case KEMembersListFilters.RenewStatus:
          addFilter(KEMembersListFilters.RenewStatus, evt ? evt.value : null);
          return;
        case KEMembersListFilters.SubscriptionId:
          addFilter(
            KEMembersListFilters.SubscriptionId,
            evt ? evt.map((x: SelectOption) => x.value) : null,
          );
          return;
        case KEMembersListFilters.OversubscribedOnly:
          addFilter(
            KEMembersListFilters.OversubscribedOnly,
            evt.target.checked,
          );
      }
    },
    [addFilter],
  );

  const plansOptions = useMemo(
    () =>
      standardPricing?.map((plan) => ({
        label: plan.membershipPlanName,
        value: plan.membershipPlanName,
      })),
    [standardPricing],
  );
  const subscriptionsListOptions = useMemo(
    () =>
      subscriptionsList?.map((subscription) => ({
        label: `KE ${formatDate(subscription.effectiveDateFrom)} - ${formatDate(
          subscription.effectiveDateTo,
        )}`,
        value: subscription.id,
      })),
    [subscriptionsList],
  );

  return {
    plansOptions,
    filters,
    onFilterChangeHandler,
    subscriptionsListOptions,
  };
};
